import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * [기본 로그 > 시스템 로그] 설정 API
 */
export default {
  /**
   * [시스템 로그 > 정책] 시스템 로그 정책 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]}        [description]
   */
  getSyslogRuleList() {
    return axios.get(`${baseUrl}/settings/syslog/get-syslog-rule-list.do`);
  },
  /**
   * [시스템 로그 > 정책 설정] Syslog 정책을 추가한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertSyslogRule(params) {
    return axios.post(`${baseUrl}/settings/syslog/insert-syslog-rule.do`, params);
  },
  /**
   * [시스템 로그 > 정책] Syslog 정책을 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateSyslogRule(params) {
    return axios.post(`${baseUrl}/settings/syslog/update-syslog-rule.do`, params);
  },
  /**
   * [시스템 로그 > 정책] Syslog 정책을 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteSyslogRule(params) {
    return axios.post(`${baseUrl}/settings/syslog/delete-syslog-rule.do`, params);
  },
  /**
   * [시스템 로그 > 정책 > 적용대상 목록 조회] 선택한 Syslog 정책이 할당된 장비 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceBySyslogTarget(params) {
    return axios.get(`${baseUrl}/settings/syslog/get-netdevice-by-syslog-target.do`, params);
  },
  /**
   * [시스템 로그 > 정책 > 적용대상 목록 조회] 수정하기 팝업에서 할당 장비 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSyslogRuleTarget(params) {
    return axios.get(`${baseUrl}/settings/syslog/get-syslog-rule-target.do`, params);
  },
  /**
   * [시스템 로그 > 정책 > 적용대상 목록 조회] 정책 할당 장비 목록을 수정한다.
   * @author Minyeong
   * @param  {[type]} querystring syslogRuleId
   * @param  {[type]} payload    수정할 장비들의 objId 배열
   * @return {[type]}        [description]
   */
  updateSyslogRuleTarget(querystring, payload) {
    return axios.post(`${baseUrl}/settings/syslog/update-syslog-rule-target.do?${querystring}`, payload);
  },
  /**
   * [시스템 로그 > 수집 설정] 트리 선택 시 objCompanyId별로 관리대상 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSyslogGroupSetList(params) {
    return axios.post(`${baseUrl}/settings/syslog/get-syslog-group-set-list.do`, params);
  },
  /**
   * [시스템 로그 > 수집 설정] 장비의 수집 여부를 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateSyslogGroupSetList(params) {
    return axios.post(`${baseUrl}/settings/syslog/update-syslog-group-set-list.do`, params);
  },
  /**
   * [시스템 로그 > 수집 설정] 장비의 Syslog Priority 설정 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params 장비의 objId
   * @return {[type]}        [description]
   */
  getObjSyslogPrioritySetList(params) {
    return axios.get(`${baseUrl}/settings/syslog/get-obj-syslog-priority-set-list.do`, params);
  },
  /**
   * [시스템 로그 > 수집 설정] 장비의 Syslog Priority 설정을 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateObjSyslogPrioritySetList(params) {
    return axios.post(`${baseUrl}/settings/syslog/update-obj-syslog-priority-set-list.do`, params);
  },
  /**
   * [시스템 로그 > 수집 설정] 장비의 Syslog Priority Set을 그룹 저장한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertObjSyslogPriorityGroupSet(params) {
    return axios.post(`${baseUrl}/settings/syslog/insert-obj-syslog-priority-group-set.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 정책 설정] objId로 장비에 할당된 정책 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSyslogRuleByObj(params) {
    return axios.get(`${baseUrl}/settings/integrated-syslog/get-syslog-rule-by-obj.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/syslog-settings.js